import React from 'react'
import { type FormikProps } from 'formik'
import TextArea from 'legacy/components/Forms/TextArea'
import { type ProductFormValues } from 'legacy/routes/catalog/types/product.types'
import FormSection from './FormSection'
import ProductTypeInfoModal from './ProductTypeInfoModal'

interface Props extends FormikProps<ProductFormValues> {}

class ProductNutrition extends React.Component<Props, {}> {
  render() {
    const { handleChange, values } = this.props

    return (
      <FormSection
        titleId="catalog.product.ingredients"
        renderAction={() => (values.editable ? null : <ProductTypeInfoModal />)}
      >
        <TextArea
          name="ingredients"
          disabled
          labelText="Ingredients"
          onChange={handleChange}
          value={values.ingredients || ''}
        />
      </FormSection>
    )
  }
}

export default ProductNutrition
